// removed by extract-text-webpack-plugin
module.exports = {"app":"app--3T_7m","title":"title--3f9JQ","contentWrapper":"contentWrapper--AHarZ","contentArea":"contentArea--SiMDT","field":"field--3-Kdn","button":"button--CeyL1 calderDark--1bp9m","Select-animation-fadeIn":"Select-animation-fadeIn--1sxeZ","Select-animation-spin":"Select-animation-spin--1u0fq"};


//////////////////
// WEBPACK FOOTER
// ./shared/css/global.css
// module id = 1156
// module chunks = 2